import { Button, Dialog } from '@zenterprise-inc/ui';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
}

const IndisProgramInstallGuideDialog = ({ isOpen, handleClose }: Props) => {
  return (
    <Dialog open={isOpen}>
      <Dialog.Header title="프로그램 설치를 완료해주세요" />
      <Dialog.Body subtext="필수 프로그램이 설치되어야 공동인증서를 불러올 수 있어요." />
      <Dialog.Footer>
        <Button.Box className="my-4 flex-1" state="primary" onClick={handleClose}>
          확인
        </Button.Box>
      </Dialog.Footer>
    </Dialog>
  );
};

export default IndisProgramInstallGuideDialog;
